<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th> {{$t('account.note.beginDate')}} </b-th>
            <b-th> {{$t('account.note.endDate')}} </b-th>
            <b-th> {{$t('account.note.type')}} </b-th>
            <b-th> {{$t('account.note.desc')}} </b-th>
            <b-th> {{$t('account.note.state')}} </b-th>
            <b-th>{{$t('account.note.operations')}}</b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="note in notes" :key="note.id">
                <b-th> {{moment(String(note.begin_date))}} </b-th>
                <b-th> 
                    <b-badge :variant="expiredIn(note.end_date) < 0 ? 'danger':'info'" v-b-popover.hover="popoverConfig(note.end_date)">
                        <span v-if="expiredIn(note.end_date) < 0">{{$t('general.expired')}}</span>
                        <span v-else>{{expiredIn(note.end_date)}} {{$t('general.expiredIn')}}</span>
                    </b-badge>
                </b-th>
                <b-td> {{types[note.apear_type].name}} </b-td>
                <b-td v-html="note.title">  </b-td>
                <b-td> 
                    <b-icon v-if="note.is_active" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('account.active')"></b-icon>
                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('account.active')"></b-icon>
                </b-td>
                <b-td> 
                    <b-icon v-b-modal.editZone icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true"  @click="openModal('edit', note)"  ></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal('delete', note)"></b-icon>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
    import i18n from '@/plugins/i18n';
    import moment from 'moment'

  let types = [
        {id: 0, name:  i18n.t('account.note.all')},
        {id: 1, name:  i18n.t('account.note.trafficList')},
        {id: 2, name:  i18n.t('account.note.account')},
    ]
    export default {
        name: "NoteForm",
        data : () => {
            return {
                types
            }
        },
         props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            openModal:function(name, data){
                this.modalType(true, 'Note',6)
                this.modalEvent(true, name, data)
            },
             moment: function(data){
                return moment(data).format('DD MMMM YYYY');
            },
            expiredIn(val) {
                const today = moment()
                const expDate = moment(val.split('T')[0])
                return expDate.diff(today, 'days') + 1
            },
            popoverConfig(data) {
                return {
                    html: true,
                    placement: 'bottom',
                    customClass: 'popover',
                    content: () => {
                        const date = this.moment(data)
                        const content = `<strong>${i18n.t('general.endDate')}: </strong>${date}`
                        return content
                    },
                }
            },
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            notes(){
                return this.$store.getters.getAccountNotes
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>

<style lang="css" scoped> 
    @import "../styles/zone.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/NoteForm.vue